// extracted by mini-css-extract-plugin
module.exports = {"propertySummaryBanner":"_3wlFZ"};